// Recovered compiled webpack factory 86437. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    !(function (e, t) {
      for (var r in t) Object.defineProperty(e, r, { enumerable: !0, get: t[r] });
    })(t, {
      REDIRECT_ERROR_CODE: function () {
        return a;
      },
      RedirectType: function () {
        return o;
      },
      isRedirectError: function () {
        return i;
      },
    }));
  let n = r(81099),
    a = "NEXT_REDIRECT";
  var o = (function (e) {
    return ((e.push = "push"), (e.replace = "replace"), e);
  })({});
  function i(e) {
    if ("object" != typeof e || null === e || !("digest" in e) || "string" != typeof e.digest)
      return !1;
    let t = e.digest.split(";"),
      [r, o] = t,
      i = t.slice(2, -2).join(";"),
      s = Number(t.at(-2));
    return (
      r === a &&
      ("replace" === o || "push" === o) &&
      "string" == typeof i &&
      !isNaN(s) &&
      s in n.RedirectStatusCode
    );
  }
  ("function" == typeof t.default || ("object" == typeof t.default && null !== t.default)) &&
    void 0 === t.default.__esModule &&
    (Object.defineProperty(t.default, "__esModule", { value: !0 }),
    Object.assign(t.default, t),
    (e.exports = t.default));
}
